import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { useConfig } from '../context/ConfigContext';

const StaffQuestions = () => {
    const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { config } = useConfig();

    const primaryColor = config?.primaryColor || '#1e40af';

    useEffect(() => {
        fetchQuestions();
        const interval = setInterval(fetchQuestions, 2000); // Poll every 2s
        return () => clearInterval(interval);
    }, []);

    const fetchQuestions = async () => {
        try {
            const response = await api.get('/questions');
            setQuestions(response.data);
        } catch (error) {
            console.error("Error fetching questions", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleStatusUpdate = async (id, newStatus) => {
        try {
            await api.put(`/questions/${id}`, { status: newStatus });
            setQuestions(questions.map(q => q.id === id ? { ...q, status: newStatus } : q));
        } catch (error) {
            console.error("Error updating status", error);
        }
    };
    const handleReplyUpdate = async (id, reply) => {
        try {
            await api.put(`/questions/${id}`, { reply });
            setQuestions(questions.map(q => q.id === id ? { ...q, reply } : q));
        } catch (error) {
            console.error("Error updating reply", error);
        }
    };

    return (
        <div className="animate-fadeIn pb-20">
            <header className="mb-8 p-6 bg-white rounded-[35px] border border-slate-100 shadow-sm flex justify-between items-center">
                <div>
                    <h1 className="text-3xl font-black text-slate-900 tracking-tight italic uppercase">Moderación Q&A</h1>
                    <p className="text-slate-400 font-bold text-xs mt-1 uppercase tracking-widest">Sincronización en vivo con el servidor</p>
                </div>
                <div className="flex gap-4">
                    <div className="text-right">
                        <p className="text-xl font-black text-slate-900">{questions.length}</p>
                        <p className="text-[10px] font-black text-slate-300 uppercase tracking-widest">Total</p>
                    </div>
                </div>
            </header>

            {isLoading ? (
                <div className="flex flex-col items-center justify-center py-20">
                    <div className="w-10 h-10 border-4 border-slate-50 border-t-purple-600 rounded-full animate-spin"></div>
                </div>
            ) : (
                <div className="space-y-6">
                    {questions.map((q) => (
                        <div key={q.id} className="bg-white p-8 rounded-[45px] border border-slate-100 shadow-xl flex flex-col gap-6 relative group transition-all hover:bg-slate-50">
                            <div className="flex justify-between items-start">
                                <div className="space-y-1">
                                    <div className="flex items-center gap-2">
                                        <span className={`w-2 h-2 rounded-full ${q.status === 'active' ? 'bg-emerald-500' : 'bg-slate-200'}`}></span>
                                        <span className="text-[10px] font-black uppercase text-slate-400">Dirigida a: {q.speaker_name}</span>
                                    </div>
                                    <p className="text-[9px] font-black text-slate-300 uppercase tracking-widest">Autor: {q.user_name}</p>
                                </div>
                                <div className="flex gap-2">
                                    <button 
                                        onClick={() => handleStatusUpdate(q.id, q.status === 'active' ? 'inactive' : 'active')}
                                        className={`px-4 py-2 rounded-xl text-[9px] font-black uppercase tracking-widest transition-all ${q.status === 'active' ? 'bg-emerald-100 text-emerald-600' : 'bg-slate-100 text-slate-400'}`}
                                    >
                                        {q.status === 'active' ? 'Visible' : 'Oculto'}
                                    </button>
                                </div>
                            </div>

                            <div className="bg-slate-100 p-6 rounded-[35px] relative">
                                <span className="absolute -top-3 left-6 bg-white px-3 py-1 rounded-full text-[8px] font-black text-slate-400 uppercase border border-slate-100">Pregunta</span>
                                <p className="text-slate-800 font-bold leading-relaxed">{q.text}</p>
                            </div>

                            <div className="space-y-3">
                                <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-4">Respuesta del Staff</label>
                                <div className="flex gap-4">
                                    <input 
                                        className="flex-grow bg-white border border-slate-100 p-5 rounded-[25px] text-sm font-medium shadow-inner focus:ring-4 focus:ring-purple-100 transition-all"
                                        placeholder="Escribe la respuesta aquí..."
                                        value={q.reply || ''}
                                        onChange={(e) => {
                                            const newQs = [...questions];
                                            const idx = newQs.findIndex(item => item.id === q.id);
                                            newQs[idx] = { ...newQs[idx], reply: e.target.value };
                                            setQuestions(newQs);
                                        }}
                                    />
                                    <button 
                                        onClick={() => handleReplyUpdate(q.id, q.reply)}
                                        className="bg-purple-600 text-white px-8 rounded-[25px] text-[10px] font-black uppercase tracking-widest shadow-lg shadow-purple-200 hover:bg-purple-700 active:scale-95 transition-all"
                                    >
                                        Enviar
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                    {questions.length === 0 && (
                        <div className="text-center py-24 bg-white rounded-[50px] border-2 border-dashed border-slate-100">
                           <p className="text-slate-400 font-black uppercase text-xs tracking-widest">No hay preguntas registradas</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default StaffQuestions;
